export const TIME_AROUND_POS = 3600; // 1 hour
export const PIXEL_RADIUS = 150; // Radius for the hover effect
export const FILTER_PANEL_WIDTH = 300; // Panel width for MapView filter
export const CHARGING_PANEL_WIDTH = "34vw";
